export const BADGE_COLOR_GREY_300 = 'Main/Grey/300';
export const BADGE_COLOR_GREY_800 = 'Main/Grey/800';
export const BADGE_COLOR_PRIMARY_800 = 'Main/Primary/800';
